export class BIM360AttributeOption {

    public id: string = '';
    public value: string = '';

    public static fromAutodeskJSON(json: any): BIM360AttributeOption
    {
        let attrOption = new BIM360AttributeOption();
        attrOption.id = json.id;
        attrOption.value = json.value;
        
        return attrOption;
    }

}